module.exports = __webpack_public_path__ + "img/notice-bvic-en.612c6aa4.jpeg";